<div class="container-fluid">
  <div class="card waiting-time-card">

    <div class="card-header">
      <span class="section-details-label">DETAILS</span>
    </div>

    <div class="card-body p-4">
      @if (alertInfo.show) {
        <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
          {{ alertInfo.message }}
        </ngb-alert>
      }
      @if (form) {
        <form [formGroup]="form">

          @for (color of sections; track color; let last = $last) {
            <div class="traffic-section">

              <h6 class="section-title section-title-{{ color }}">
                {{ getSectionLabel(color) }}
              </h6>

              @for (i of getRowIndexes(color); track i) {
                <div class="notification-row">

                  <div class="col-status d-flex flex-column">
                    @if (i === 0) {
                      <label class="field-label">Status</label>
                      <div class="traffic-circles">
                        <span class="traffic-circle circle-{{ color }}-light"></span>
                        <span class="traffic-circle circle-{{ color }}"></span>
                      </div>
                    }
                  </div>
                  <div class="col-time">
                    @if (i === 0) {
                      <input-field
                        label="Time"
                        type="time"
                        [inputFormControl]="getTimeControl(color)"
                      />
                    }
                  </div>

                  @if (i < getNotificationsArray(color).length) {
                    <div class="col-name">
                      <select-field
                        label="Name"
                        [options]="userOptions[color]"
                        [selectFormControl]="getUserIdControl(color, i)"
                        (selectionChange)="onUserSelect(color, i, $event)"
                      />
                    </div>

                    <div class="col-role-action">
                      <input-field
                        label="Role"
                        [placeholder]="'Role'"
                        [readonly]="true"
                        [inputFormControl]="getRoleControl(color, i)"
                      />
                      <button
                        type="button"
                        class="btn btn-outline-danger btn-delete mt-2"
                        title="Remove recipient"
                        (click)="confirmRemoveNotification(color, i)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  }

                </div>
              }

              <div class="mt-3">
                <button
                  type="button"
                  class="btn btn-sm btn-add btn-add-{{ color }}"
                  (click)="addNotification(color)"
                >
                  + Add someone to notify
                </button>
              </div>

            </div>

            @if (!last) {
              <hr class="section-divider">
            }
          }

        </form>
      }
    </div>

    <div class="card-footer text-center py-3">
      <button type="button" class="btn btn-success px-5 py-2" (click)="saveSettings()">
        Save
      </button>
    </div>

  </div>
</div>
